import React, { useEffect } from "react";
import Stack from "@mui/material/Stack";
import Chip from "@mui/material/Chip";
import {
  Box,
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  Typography,
} from "@mui/material";

function HouseKeepingAnalytics({
  analyticsName,
  analyticsValue,
  bgColor,
  handelFilter,
  selectedCard,
}) {
  const selected = {
    width: 135,
    height: 175,
    marginLeft: "0px",
    transform: "scale(1.1)",
  };
  const notSelected = {
    width: 130,
    height: 160,
  };

  return (
    <Card
      sx={selectedCard === analyticsName[0] ? selected : notSelected}
      onClick={() => handelFilter(analyticsName[0])}
    >
      <CardActionArea>
        <CardMedia
          component="div"
          sx={{ backgroundColor: bgColor, height: "25px" }}
        />
        <CardContent>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
            }}
          >
            <Typography
              gutterBottom
              variant="h2"
              // sx={{ fontSize: "68px", fontWeight: 500 }}
            >
              {analyticsValue}
            </Typography>
            <Typography
            // sx={{ fontSize: "15.5px", fontWeight: 500 }}
            >
              {analyticsName[0] || "ALL ROOMS"}
            </Typography>
          </Box>
        </CardContent>
      </CardActionArea>
    </Card>
  );

  // return (
  //   <div>
  //     <Stack direction="row">
  //       <Chip
  //         onClick={() => handelFilter(analyticsName[0])}
  //         style={{ backgroundColor: bgColor, cursor: "pointer" }}
  //         label={
  //           <Stack direction="row" spacing={5}>
  //             <div
  //               style={{
  //                 fontSize: "15px",
  //                 color: "white",
  //                 marginTop: "auto",
  //                 marginBottom: "auto",
  //               }}
  //             >
  //               {analyticsName}
  //             </div>
  //             <div
  //               style={{
  //                 fontSize: "20px",
  //                 color: "white",
  //                 fontWeight: "500",
  //                 marginTop: "auto",
  //                 marginBottom: "auto",
  //               }}
  //             >
  //               {analyticsValue}
  //             </div>
  //           </Stack>
  //         }
  //         //   variant="outlined"
  //       />
  //     </Stack>
  //   </div>
  // );
}

export default HouseKeepingAnalytics;
